// extracted by mini-css-extract-plugin
export default {"Map":"GMapForMarker_Map__kquya"};